export enum AliasesAPI {
    getPublicAliasBinding = "AliasBindings.GetPublicAliasBinding",
}
